<template>
  <div class="border-radius" :class="selected?'active':''">
    <div v-if="isAdd" @click="onAddBrandClick"
        class="brand-item-wrap flex flex-col items-center justify-center relative">
      <van-image class="-mt-10" :src="require('@/assets/icons/v2/icon_brand_add_new.png')" fit="cover" width="40"
          height="40"/>
      <span class="add-new">Add New</span>
    </div>

    <div @click="onSelectBrandClick" v-else class="brand-item-wrap flex flex-col items-center relative  justify-center">
      <van-image :src="brandUrl" fit="contain" style="max-width:50%; max-height:100px"/>
      <div v-if="isPending" class="pending">Pending</div>
      <div v-else class="pending" @click="onEdit">Edit</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isAdd: Boolean,
    selected: {
      type: Boolean,
      default: false
    },
    brandUrl: {
      type: String,
      default: ""
    },
    isPending: {
      type: Boolean,
      default: false
    }
  },
  name: "BrandItem",
  methods: {
    onAddBrandClick() {
      this.$emit("onAddBrand");
    },
    onSelectBrandClick() {
      this.$emit("onSelectBrand");
    },
    onEdit() {
      this.$emit('onEdit')
    }
  }

};
</script>


<style scoped lang="less">
.brand-item-wrap {
  background: #FFFFFF;
  border-radius: 12px;
  width: 100%;
  height: 150px;
  border: 1px solid #E8E8E8;
}

.active {
  border-radius: 12px;
  border: 1px solid #679AFF;
}


.pending {
  position: absolute;
  background: #F1F6FF;
  border-radius: 4px;
  width: 49px;
  height: 20px;
  line-height: 20px;
  top: 12px;
  right: 12px;
  font-size: 10px;
  text-align: center;
}

.add-new {
  position: absolute;
  text-align: center;
  border-radius: 4px;
  bottom: 12px;
  left: 12px;
  right: 12px;
  font-size: 17px;
}

.brand-img-wrap {
  position: absolute;
  left: 16px;
  right: 16px;
  top: 32px;
  top: 50%;
  transform: translateY(-50%);
}
</style>